<template>
  <CcGoods :component="component" :context="context" :show-main="false" />
</template>

<script>
import CcGoods from '../components/goods/Goods'

export default {
  name: 'GoodsComp',
  components: { CcGoods },
  props: {
    component: {
      type: Object,
      default: null
    },
    context: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped></style>
